import { DELIVERABLES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/deliverables_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'deliverablesIndex',
	'DELIVERABLE_WORK_ORDERS',
	'PROJECT_TASKS_DELIVERABLES',
	'PROJECT_OVERVIEW_DELIVERABLES',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
